import BookingModel from 'uplisting-frontend/models/booking';
import BookingRequestModel from 'uplisting-frontend/models/booking-request';

export enum InboxMessageChannel {
  airbnb = 'airbnb',
  bookingDotCom = 'booking_dot_com',
  google = 'google',
  homeAway = 'home_away',
  uplisting = 'uplisting',
}

export interface IInboxMessageSchema {
  content: string;
  channel: InboxMessageChannel;
  inbound: boolean;
  from: string;
  unread: boolean;
  starred: boolean;
  archived: boolean;
  status: string;
  lastMessageAt: Date;
  lastMessageType: string;
  lastMessageId: number;
  propertyName: string;
  guestName: string;
  guestProfilePicture: string;

  bookings: BookingModel[];
  bookingRequests: BookingRequestModel[];
}
